module.exports = __webpack_public_path__ + "img/added-to-cart.5f947f77.svg";